// extracted by mini-css-extract-plugin
module.exports = {"image":"style__image__hkBVB"};